(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sidenavbar", [], factory);
	else if(typeof exports === 'object')
		exports["sidenavbar"] = factory();
	else
		root["sidenavbar"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 